import * as tslib_1 from "tslib";
import selectFocusedInboxOption from '../actions/selectFocusedInboxOption';
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
var FocusedFull = /** @class */ (function (_super) {
    tslib_1.__extends(FocusedFull, _super);
    function FocusedFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            selectFocusedInboxOption(option.key === 'true');
        };
        return _this;
    }
    FocusedFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var isFocusedEnabled = getFallbackValueIfNull(optionStore.isEnabled, userOptions.IsFocusedInboxEnabled);
        return (React.createElement(ChoiceGroup, { selectedKey: "" + isFocusedEnabled, label: strings.options_focused_label, options: [
                {
                    key: 'true',
                    text: strings.options_focused_enabled,
                },
                {
                    key: 'false',
                    text: strings.options_focused_disabled,
                },
            ], onChange: this.onChange }));
    };
    FocusedFull = tslib_1.__decorate([
        reactive({
            optionStore: function () { return store; },
            userOptions: function () { return getUserConfiguration().UserOptions; },
        })
    ], FocusedFull);
    return FocusedFull;
}(React.Component));
export default FocusedFull;
//# sourceMappingURL=FocusedFull.js.map